import Botfooter from "./footer";
import Navbar from "./navbar";

const MainLayout = ({ children }) => {
  return (
    <div className="">
      <Navbar />
      <div className="margin-90"></div>
      {children}
      <Botfooter />
    </div>
  );
};

export default MainLayout;
